import { go, Model } from 'oderon-vue'

export const ServiceBI = new Model('/billing-items')

ServiceBI.patch = (ids, what) => go.patch('/billing-items', { ids, what })
ServiceBI.getGrid = (ps) => go.get('/billing-items/grid', ps)
ServiceBI.getGridSpec = (ps) => go.get('/billing-items/grid/spec', ps)
ServiceBI.downloadGrid = (ps) => go.download('/billing-items/download', ps)
ServiceBI.downloadTechReport = (ps) => {
  return go('get', '/billing/tech/download', ps, {
    asBlob: true,
    withFilename: true
  })
}
